
  
  // GSAP HOVER MODULE
  // book online widget hover effect
  (function(window, document, $, undefined){
    var element = $('.site-header .book-online svg');
    var over  = {css:{width:'230px', height:'80px', top:'-5px', left:'-5px'}, ease:Elastic.easeOut.config(2.5, 0.4)};
    var out    = {css:{width:'220px', height:'70px', top:'0px', left:'0px'}, ease:Quint.easeOut};//ORIGINAL STATE
    TweenMax.set(element,out);//needed otherwise first tween doesnt work for some reason
    $(".site-header .book-online").hover(function(){
      TweenMax.to(element,0.6,over);
    }, function(){
      TweenMax.to(element,0.5,out);
    });
  })(window, document, jQuery);


  // GSAP HOVER MODULE
  //Social icons
  (function(window, document, $, undefined){
    var element = $('.site-header .social-icons li');
    var over  = {css:{
      scale:'1.4',
    }, ease:Sine.easeOut};
    var out    = {css:{
      scale:'1',
    }, ease:Sine.easeIn, delay:0.05};//ORIGINAL STATE
    TweenMax.set(element,out);//needed otherwise first tween doesnt work for some reason
    element.hover(function(){
      TweenMax.to($(this),0.05,over);
      TweenMax.to($(this),0.1,out);
    }, function(){
    });
  })(window, document, jQuery);



  // // GSAP HOVER MODULE
  // // Main navigation rollovers, zoom in from 0 opacity and 0 scale to 1.
  // (function(window, document, $, undefined){
  //   $('.main-navigation .main-menu ul>li').prepend($('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 761 151" preserveAspectRatio="none" class="fl-block-bg-nav"><polygon points="0 0 761 9 756 151 12 151 0 0"/></svg>'));

  //   var element = $('.main-navigation .main-menu ul>li');
  //   var over  = {css:{
  //     scale:'1',
  //     opacity:'1',
  //   }, ease:Elastic.easeOut.config(0.5, 0.4)};
  //   var out    = {css:{
  //     scale:'0',
  //     opacity:'0',
  //   }, ease:Sine.easeIn};//ORIGINAL STATE
  //   // var over2  = {css:{
  //   //   height:200,
  //   // }, delay:'0.2', ease:Elastic.easeOut.config(0.5, 0.4)};
  //   // var out2    = {css:{
  //   //   height:0,
  //   // }, delay:'0.2', ease:Sine.easeOut};//ORIGINAL STATE
  //   // TweenMax.set(element.find('svg'),out);//needed otherwise first tween doesnt work for some reason
  //   // TweenMax.set($('.megamenu'),out2);//needed otherwise first tween doesnt work for some reason
  //   element.hover(function(){
  //     TweenMax.to($(this).find('svg'),0.2,over);
  //     // TweenMax.to($('.megamenu'),0.5,over2);
  //   }, function(){
  //     TweenMax.to($(this).find('svg'),0.1,out);
  //     // TweenMax.to($('.megamenu'),0.2,out2);
  //   });
  // })(window, document, jQuery);



  // // GSAP HOVER MODULE
  // // Main nav rollovers using inline SVG, like social icons.
  // (function(window, document, $, undefined){
  //   $('.main-navigation .main-menu ul>li').prepend($('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 761 151" preserveAspectRatio="none" class="fl-block-bg-nav"><polygon points="0 0 761 9 756 151 12 151 0 0"/></svg>'));

  //   var element = $('.main-navigation .main-menu ul>li');
  //   var over  = {css:{
  //     scale:'1.1',
  //   }, ease:Sine.easeOut};
  //   var out    = {css:{
  //     scale:'1',
  //   }, ease:Sine.easeIn, delay:0.05};//ORIGINAL STATE
  //   // var over2  = {css:{
  //   //   height:200,
  //   // }, delay:'0.2', ease:Elastic.easeOut.config(0.5, 0.4)};
  //   // var out2    = {css:{
  //   //   height:0,
  //   // }, delay:'0.2', ease:Sine.easeOut};//ORIGINAL STATE
  //   // TweenMax.set(element.find('svg'),out);//needed otherwise first tween doesnt work for some reason
  //   // TweenMax.set($('.megamenu'),out2);//needed otherwise first tween doesnt work for some reason
  //   element.hover(function(){
  //     TweenMax.to($(this).find('svg'),0.05,over);
  //     TweenMax.to($(this).find('svg'),0.1,out);
  //     // TweenMax.to($('.megamenu'),0.5,over2);
  //   }, function(){
  //     // TweenMax.to($('.megamenu'),0.2,out2);
  //   });
  // })(window, document, jQuery);



  // GSAP HOVER MODULE
  // Main nav rollovers using inline SVG, popping nice.
  (function(window, document, $, undefined){
    // add svg's to the nav li's
    // This is now done with 'before' on the nav menu wp call
    // $('.main-navigation .main-menu ul>li').prepend($('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 761 151" preserveAspectRatio="none" class="fl-block-bg-nav"><polygon points="0 0 761 9 756 151 12 151 0 0"/></svg>'));

    // var element = $('.main-navigation .main-menu ul>li');
    var element = $('.main-navigation .navigation-bar .ubermenu .ubermenu-item-level-0');
    var over  = {css:{
      scale:'1.06',
      // width:'1',
    }, ease:Elastic.easeOut.config(1.5, 0.4)};
    var out    = {css:{
      scale:'1',
      // opacity:'0',
    }, delay:0, ease:Sine.easeIn};//ORIGINAL STATE
    // var over2  = {css:{
    //   height:200,
    // }, delay:'0.2', ease:Elastic.easeOut.config(0.5, 0.4)};
    // var out2    = {css:{
    //   height:0,
    // }, delay:'0.2', ease:Sine.easeOut};//ORIGINAL STATE
    // TweenMax.set(element.find('svg'),out);//needed otherwise first tween doesnt work for some reason
    // TweenMax.set($('.megamenu'),out2);//needed otherwise first tween doesnt work for some reason
    element.hover(function(){
      TweenMax.to($(this).find('.ubermenu-custom-content').first(),0.5,over);
      // TweenMax.to($('.megamenu'),0.5,over2);
    }, function(){
      TweenMax.to($(this).find('.ubermenu-custom-content').first(),0.1,out);
      // TweenMax.to($('.megamenu'),0.2,out2);
    });
  })(window, document, jQuery);



